module.exports = __webpack_public_path__ + "static/media/dothrakit.bf77b2b2.svg";